<div class="container-fluid dialog-wrapper">
  <!-- <div class="doc-upload"> -->
  <div class="dialog-header">
    <div class="dialog-header-title">
      <img src="{{ docSvgLoc }}" alt="logo" class="header-icon" />
      <span class="dialog-header-text extra-space">{{ dialogTitle }}</span>
    </div>
    <img src="assets/icons/dashboard-icons/close-pink-icon.svg" (click)="closeDialog()" class="close-btn" />
  </div>
  <div class="dialog-body mt-3" *ngIf="type === 'ADD' || type === 'EDIT'">
    <form [formGroup]="form" (ngSubmit)="submit()" class="add-document-form" [class.loading]="isLoading">
      <div class="forms-container">
        <div class="add-document" *ngIf="type === 'ADD'">
          <mat-form-field appearance="outline">
            <mat-label>Select Document Type</mat-label>
            <mat-select [formControl]="selectedDocType">
              <mat-option *ngFor="let type of documentTypes" [value]="type" [disabled]="isDisabled(type)">
                {{getFormattedType(type)}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button (click)="onAddDocClick()" [disabled]="!selectedDocType.value" class="view-btn">
            Add Document
          </button>
        </div>

        <div class="forms-types">
          <div formArrayName="documents" *ngFor="
              let group of documents.controls;
              let i = index;
              trackBy: trackByFn
            " class="form">
            <div>
              <h3>
                {{ getFormattedType(group?.get("type")?.value) }}
                Document
              </h3>
            </div>
            <div class="form-fields">
              <ng-container class="height-adjust" [formGroupName]="i"
                *ngIf="documentFieldMap[group.get('type')?.value] as fields">
                <div *ngFor="let field of fields">


                  <mat-form-field appearance="outline" *ngIf="field.type === 'select'">
                    <mat-label>Select Document Type</mat-label>


                    <mat-select [formControlName]="field.name" (selectionChange)="ifAadharNo(i, $event.value)">
                      <mat-option *ngFor="let type of addressProofType" [value]="type" matTooltip="Already uploaded"
                        matTooltipDisabled="!isDisabled(type)">
                        {{ type | titlecase }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field *ngIf="field.type !== 'date' && field.type !== 'select'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput [type]="field.type" [formControlName]="field.name" [inputMode]="field.inputMode"
                      required (input)="shouldFormatAadhaar(i, field.name,selectedAddressProofType) ? formatAadhaar(i, field.name, $event) : null"/>
                    <mat-error *ngIf="group.get(field.name)?.hasError('required')">
                      {{ field.label }} is required.
                    </mat-error>
                    <mat-error *ngIf="group.get(field.name)?.hasError('pattern')">
                      {{ field.errorMessage }}
                    </mat-error>
                  </mat-form-field>

                  <!-- date-field -->
                  <mat-form-field *ngIf="field.type === 'date'" appearance="outline" class="w-full">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput [matDatepicker]="picker3" placeholder="dd/mm/yyyy" [formControlName]="field.name" />
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                    <mat-error *ngIf="group.get(field.name)?.hasError('required')">
                      {{ field.label }} is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </ng-container>

              <!-- File Upload Field -->
              <div class="wrapper-container"  [ngClass]="{ 'uploaded-container': documents.at(i)?.get('originalFile')?.value }">
                <div class="wrapper" [ngClass]="{ 'uploaded': documents.at(i)?.get('originalFile')?.value }">
                  <button class="upload" type="button"
                    (click)="!documents.at(i)?.get('originalFile')?.value && fileInput.click()" [matTooltip]="
        !documents.at(i)?.get('removed')?.value
          ? (documents.at(i)?.get('originalFile')?.value?.name
              ? documents.at(i)?.get('originalFile')?.value?.name
              : (data?.document?.document_name ? data.document.document_name : null))
          : null
      " matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [ngClass]="{ 'upload-btn': documents.at(i)?.get('originalFile')?.value }">
                    {{
                    documents.at(i)?.get("originalFile")?.value?.name
                    ? documents.at(i)?.get("originalFile")?.value?.name
                    : (documents.at(i)?.get("removed")?.value
                    ? "Upload Document"
                    : (data?.document?.document_name
                    ? data.document.document_name
                    : "Upload Document"
                    )
                    )
                    }}
                  </button>

                  <button type="button" class="remove-btn" (click)="removeFile(i)"
                    *ngIf="documents.at(i)?.get('originalFile')?.value" matTooltip="Remove the uploaded document"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip">
                    <img src="assets/icons/dashboard-icons/close-pink-icon.svg" class="close-btn" />
                  </button>

                  <input type="file" style="display: none" accept=".png,.jpg,.jpeg,.pdf" [id]="'fileInput-' + i"
                    (change)="onFileChange($event, i)" #fileInput />
                </div>

                <!-- Error / Supported files message -->
                <div class="file-message">
                  <span [ngClass]="{ 'error': fileErrors[i] }">
                    {{
                    fileErrors[i]
                    ? 'Unsupported file type.'
                    : 'Supported formats: PNG, JPG, JPEG, and PDF files only.'
                    }}
                  </span>
                </div>
              </div>

              <div *ngIf="type === 'ADD'">
                <div class="three-dots-container" [matMenuTriggerFor]="beforeMenu">
                  <img src="assets/icons/3dots.png" class="threedots" />
                  <mat-menu class="matmenu" #beforeMenu="matMenu" xPosition="before">
                    <ng-container *ngIf="documents.at(i)?.get('originalFile')?.value; else noFile">
                      <button mat-menu-item class="first" (click)="openPreviewModal(i)">
                        <span class="connect">View</span>
                      </button>
                    </ng-container>

                    <ng-template #noFile>
                      <button mat-menu-item class="first custom-disabled" (click)="$event.stopPropagation()">
                        <span class="connect">View</span>
                      </button>
                    </ng-template>
                    <button *ngIf="type === 'ADD'" mat-menu-item (click)="removeDocument(i)">
                      <span class="bold">Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>


              <div *ngIf="type === 'EDIT' && documents.at(i)?.get('originalFile')?.value">
                <button class="edit-view-btn" type="button" (click)="openPreviewModal(i)">
                  <span class="connect">View</span>
                </button>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="documents-submit">
        <button type="submit" [disabled]="isSaveDisabled">
          Save
        </button>
      </div>
    </form>
  </div>

  <ng-template #previewContent let-modal>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-body">
      <div *ngIf="!isImage">
        <pdf-viewer [src]="document_download_url" [rotation]="0" [fit-to-page]="true" [original-size]="false"
          [show-all]="true" class="pdf-attachment"></pdf-viewer>
      </div>

      <div *ngIf="isImage">
        <img class="preview-img" [src]="document_view_url" />
      </div>
    </div>
  </ng-template>

  <!-- </div> -->
</div>